import React from 'react/addons';
import cx from 'classnames';
import pad from 'pad';
import _ from 'underscore';
import SelectOne from 'ofs/forms/inputs/simple-choice';
import FieldContainer from 'ofs/react/fields/fieldcontainer';


module.exports = React.createClass({
  getInitialState: function() {
    /*
     * Here we're using state to hold onto temporary
     * values when one select change causes us to
     * have a temporary unusable value for the time.
     * eg 'HH:null:null' or 'null:MM:SS'
     */
    return {
      tempMinute: null,
      tempHour: null,
      tempSecond: null
    };
  },

  propTypes: {
    useSeconds: React.PropTypes.bool,
    minuteStep: React.PropTypes.number,
    secondStep: React.PropTypes.number,
  },

  getDefaultProps: function() {
    return {
      useSeconds: false,
      minuteStep: 5,
      secondStep: 5
    };
  },

  stringValue: function(hour, minute, second) {
    return pad(2, hour, '0') + ':' + pad(2, minute, '0') + ':' + pad(2, second, '0');
  },

  handleHourChange: function(event) {
    const {value} = event.target;
    const {model, field} = this.props;
    var currentValue;
    var newValue;

    if (model && field) {
      currentValue = model.get(field);
    } else {
      currentValue = this.props.value;
    }

    var minuteValue = currentValue ? currentValue.split(':')[1] : null;
    var secondValue;

    if (this.props.useSeconds) {
      secondValue = currentValue ? currentValue.split(':')[2] : null;
    } else {
      secondValue = '00';
    }

    if ((this.state.tempMinute || minuteValue) && (this.state.tempSecond || secondValue)) {
      newValue = this.stringValue(value, this.state.tempMinute || minuteValue, this.state.tempSecond || secondValue);
      if (model && field) {
        model.set(field, newValue);
      } else if (this.props.onChange) {
        this.props.onChange(newValue);
      }
      this.setState({
        tempHour: null,
        tempMinute: null,
        tempSecond: null
      });
    } else {
      this.setState({
        tempHour: value
      });
    }
  },

  handleMinuteChange: function(event) {
    const {value} = event.target;
    var {model, field} = this.props;
    var currentValue;
    var newValue;

    if (model && field) {
      currentValue = model.get(field);
    } else {
      currentValue = this.props.value;
    }

    var hourValue = currentValue ? currentValue.split(':')[0] : null;
    var secondValue;

    if (this.props.useSeconds) {
      secondValue = currentValue ? currentValue.split(':')[2] : null;
    } else {
      secondValue = '00';
    }
    if ((this.state.tempHour || hourValue) && (this.state.tempSecond || secondValue)) {
      newValue = this.stringValue(this.state.tempHour || hourValue, value, this.state.tempSecond || secondValue);

      if (model && field) {
        model.set(field, newValue);
      } else if (this.props.onChange) {
        this.props.onChange(newValue);
      }
      this.setState({
        tempHour: null,
        tempMinute: null,
        tempSecond: null
      });
    } else {
      this.setState({
        tempMinute: value
      });
    }
  },

  handleSecondChange: function(event) {
    const {value} = event.target;
    var {model, field} = this.props;
    var currentValue;
    var newValue;

    if (model && field) {
      currentValue = model.get(field);
    } else {
      currentValue = this.props.value;
    }

    var hourValue = currentValue ? currentValue.split(':')[0] : null;
    var minuteValue = currentValue ? currentValue.split(':')[1] : null;

    if ((this.state.tempHour || hourValue) && (this.state.tempMinute || minuteValue)) {
      newValue = this.stringValue(this.state.tempHour || hourValue, this.state.tempMinute || minuteValue, value);

      if (model && field) {
        model.set(field, newValue);
      } else if (this.props.onChange) {
        this.props.onChange(newValue);
      }
      this.setState({
        tempHour: null,
        tempMinute: null,
        tempSecond: null
      });
    } else {
      this.setState({
        tempMinute: value
      });
    }
  },

  render: function() {
    var model = this.props.model;
    var field = this.props.field;
    var error;
    var value;
    var hourValue = null;
    var minuteValue = null;
    var secondValue = null;

    var classes = cx({
      'field': true,
    });

    var hourChoices = _.map(_.range(0, 24), function(i) {
      return {value: i, name: pad(2, i, '0')};
    });
    var minuteChoices = _.map(_.range(0, 60, this.props.minuteStep), function(i) {
      return {value: i, name: pad(2, i, '0')};
    });
    var secondChoices = _.map(_.range(0, 60, this.props.secondStep), function(i) {
      return {value: i, name: pad(2, i, '0')};
    });

    if (model && field) {
      value = model.get(field);
    } else {
      value = this.props.value;
    }

    var parts = value ? value.split(':') : null;

    if (parts) {
      hourValue = parseInt(parts[0], 10);
      minuteValue = parseInt(parts[1], 10);
      if (parts.length === 3) {
        secondValue = parseInt(parts[2], 10);
      } else {
        secondValue = 0;
      }
    }

    return (
      <div className={classes}>
        <FieldContainer label={this.props.label}>
          <div className="ofs-TimeSelect ofs-TimeSelect--inline">
            <SelectOne className="ofs-SimpleChoice--inline ofs-TimeSelect__Field" ref="hourField" allowEmpty={false} defaultValue={hourValue} options={hourChoices} onChange={this.handleHourChange} placeholder="--"/>
            <SelectOne className="ofs-SimpleChoice--inline ofs-TimeSelect__Field" ref="minuteField" allowEmpty={false} defaultValue={minuteValue} options={minuteChoices} onChange={this.handleMinuteChange} placeholder="--"/>
            {this.props.useSeconds ? <SelectOne className="ofs-SimpleChoice--inline ofs-TimeSelect__Field" ref="secondField" allowEmpty={false} defaultValue={secondValue} options={secondChoices} onChange={this.handleSecondChange} placeholder="--"/> : null}
          </div>
          {error ? <p className="warning">{error}</p> : null}
        </FieldContainer>
      </div>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/react/fields/timefield.jsx
 **/